<template>
  <div
    class="flex flex_center contractStatusScheduled"
    :class="`contractStatus_scheduled_${status}`"
  >
    {{$t(scheduledKey) }}
  </div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";

export default {
  data() {
    return {};
  },

  methods: {},
  computed: {
	scheduledKey() {
		let { data, companyType } = this.params;
		let key = "";
		let statusItem = enumDef.trackPayStats.properties[data.status];
		if (statusItem) {
			if (companyType === 'supplier') {
				key = statusItem.nextStepKey;
			} else {
				key = statusItem.debtorStatusKey;
			}
		}
		return key;
    },
      status() {
		if (this.params.companyType === 'supplier') {
			switch (this.params.data.status) {
				case enumDef.trackPayStats.New:
					return "yellow";
				case enumDef.trackPayStats.Submitted:
				case enumDef.trackPayStats.Confirmed:
				case enumDef.trackPayStats.Transferred:
					return "grey";
				case enumDef.trackPayStats.SentToExternal:
					return "yellow";
				case enumDef.trackPayStats.Tracking:
				case enumDef.trackPayStats.Arrived:
					return "grey";
				case enumDef.trackPayStats.Rejected:
					return "pink";
			}
		} else {
			switch (this.params.data.status) {
				case enumDef.trackPayStats.Submitted:
				case enumDef.trackPayStats.Confirmed:
					return "yellow";
				case enumDef.trackPayStats.Transferred:
				case enumDef.trackPayStats.SentToExternal:
				case enumDef.trackPayStats.Tracking:
				case enumDef.trackPayStats.Arrived:
					return "grey";
				case enumDef.trackPayStats.Settled:
					return "yellow";
				case enumDef.trackPayStats.Rejected:
					return "pink";
			}
		}
      }
  }
};
</script>
<style lang="scss" scoped>
.contractStatusScheduled {
	width: 175px;
	text-align: center;
	display: inline-block;
	font-weight: bold;
	&.contractStatus_scheduled_yellow {
		border-left: 5px solid #F4CE67;
		color: #997002;
		background-color: #FAECC7;
	}
	&.contractStatus_scheduled_grey {
		border-left: 5px solid #8C939B;
		color: #8C939B;
		background-color: #E6E7E8;
	}
	&.contractStatus_scheduled_pink {
		border-left: 5px solid #D1597E;
		color: #BD2A57;
		background-color: #F5CEE0;
	}
}
</style>
